import React, {Component} from 'react'

const asyncWrapper = (WrappedComponent) => {
  class LoadingComponent extends Component {
    constructor(props) {
      super(props)

      this.state = {
        loading: true,
        error: false
      }
    }

    setLoading() {
      this.setState(prevState => (
        {loading: !prevState.loading, error: false}
      ))
    }

    setLoadingNew(isLoading) {
      this.setState(prevState => (
        {loading: isLoading, error: false}
      ))
    }

    setError() {
      this.setState(prevState => (
        {error: !prevState.error, loading: false}
      ))
    }

    handleErrors(response) {
      if (!response.ok) {
        this.setError()
        throw Error(response.statusText);
      }
      return response.json();
    }

    render() {
      return(
        <WrappedComponent
          {...this.state}
          {...this.props}
          setLoading={this.setLoading.bind(this)}
          setLoadingNew={this.setLoadingNew.bind(this)}
          setError={this.setError.bind(this)}
          handleErrors={this.handleErrors.bind(this)}
        />
      )
    }
  }

  return LoadingComponent
}

export default asyncWrapper;


// WEBPACK FOOTER //
// ./src/shared/javascripts/hocs/asyncWrapper.jsx